import axios from 'axios'

const service = axios.create({
    baseURL: "/server/web",
    timeout: 10000
})

export default service